import {useLocation} from "react-router-dom";
import React from "react";

//Стили
import './style/payments.css';

//Страница оплаты (Совершить оплату)
export default function FormPayAnyWay() {
    const location = useLocation();
    let pay = location.state;

    return (
        <>
            <div id={'payments'}>
                <div id={'payments-block'}>
                    <div className={"text-center payments_img_block"}>
                        <img src={"../icons/visa.svg"} alt={"!#"} className={"mx-2 payments_img"}/>
                        <img src={"../icons/mastercard.svg"} alt={"!#"} className={"payments_img"}/>
                        <img src={"../icons/mir.svg"} alt={"!#"} className={"mx-2 payments_img"}/>
                        <img src={"../icons/sbp.svg"} alt={"!#"} className={"mx-2 payments_img"}/>
                    </div>
                    <div className={"greeting-text-block"}>
                        <h1 className={"text-center"}>
                            Оплатить услуги связи в размере
                        </h1>
                        <p className={'pb-0 fw-bold text-center payments_amount'}>
                            {Number(pay?.mnt_amount) < 1 ? 1 : pay?.mnt_amount} ₽
                        </p>
                    </div>
                    <div className={"text-center mt-3"}>
                        <form method={"post"} action={"https://www.payanyway.ru/assistant.htm"}>
                            <input type={"hidden"} name={"MNT_ID"} value={pay?.mnt_id}/>
                            <input type={"hidden"} name={"MNT_AMOUNT"} value={Number(pay?.mnt_amount) < 1 ? 1 : pay?.mnt_amount}/>
                            <div className={'mt-2'}>
                                <p className={'mx-2 mb-0 text-center payments_text'}>
                                    Нажимая кнопку «Продолжить», вы подтверждаете,
                                    что согласны на <a href={"https://idgos.ru/privacy"} target={"_blank"} className={'target-link'}>
                                    обработку персональных данных</a>
                                </p>
                            </div>
                            <div className={'fixed-bottom mx-auto d-flex justify-content-center payments_continue'}>
                                <button type={"submit"} className={'view-btn margin40_bottom w-100 cursor weight600_project size14_project border-0 color_white background_bondi'}>
                                    Продолжить
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};
